import { DEMO_CALLABLE_RESPONSES, DEMO_WEATHER } from './fixtures.js';
import { FUNCTIONS_BASE } from '../siteConfig.js';

const originalFetch = window.fetch.bind(window);

function matchDemoResponse(url, init) {
  const u = String(url);

  if (u.includes('/searchLocalNews')) {
    return DEMO_CALLABLE_RESPONSES.searchLocalNews;
  }
  if (u.includes('/api/weather/current')) {
    return DEMO_WEATHER.current.rawData
      ? { observations: [DEMO_WEATHER.current.rawData] }
      : DEMO_WEATHER.current;
  }
  if (u.includes('/api/weather/hourly')) {
    return DEMO_WEATHER.hourly;
  }
  if (u.includes('/api/getInvoices')) {
    return DEMO_CALLABLE_RESPONSES.getInvoices;
  }
  if (u.includes('/voteOnPollNew')) {
    return { success: true, message: 'Vote recorded (demo)' };
  }
  if (u.includes(FUNCTIONS_BASE) || u.includes('cloudfunctions.net')) {
    const segment = u.split('/').pop()?.split('?')[0];
    if (DEMO_CALLABLE_RESPONSES[segment]) {
      return DEMO_CALLABLE_RESPONSES[segment];
    }
    return { success: true, demo: true };
  }
  return null;
}

export function installDemoFetchInterceptor() {
  if (window.__nmrDemoFetchInstalled) return;
  window.__nmrDemoFetchInstalled = true;

  window.fetch = async (url, init) => {
    const demoBody = matchDemoResponse(url, init);
    if (demoBody) {
      return new Response(JSON.stringify(demoBody), {
        status: 200,
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return originalFetch(url, init);
  };
}